<template>
    <div class="add-column-form">
        <div class="form">
            <div class="field">
                <label class="label">{{ $t("wp.columnType") }}</label>
                <a-select :value="columnType" s @change="handleColumnTypeChange">
                    <a-select-option v-for="col in getAllowedColumns()" :value="col.id" :key="col.id">
                        {{ col.title }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="field" v-if="columnType === 'custom'">
                <label class="label">{{ $t("wp.columnName") }}</label>
                <a-input ref="userNameInput" v-model="columnName" placeholder="Type Column Name" :required="true">
                    <a-tooltip slot="suffix" title="column name using on tables and message templates">
                        <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                    </a-tooltip>
                </a-input>
            </div>
            <div class="field">
                <label class="label">{{ $t("wp.defaultValue") }}</label>
                <a-input ref="userNameInput" v-model="defaultValue" :placeholder="$t('wp.defaultValue')">
                    <a-tooltip slot="suffix" :title="$t('wp.setDefaultValue')">
                        <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                    </a-tooltip>
                </a-input>
            </div>

            <a-divider />
            <div class="buttons">
                <a-button @click="cancel">{{ $t("wp.cancel") }}</a-button>
                <a-button type="primary" @click="save" :disabled="!isValid()"> {{ $t("wp.save") }}</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../utils/log2";
import _ from "lodash";

const log = log2("AddColumnForm");
export default {
    name: "AddColumnForm",
    props: {
        onCompleted: {
            type: Function,
            required: true,
        },
        onCancelled: {
            type: Function,
            required: true,
        },
        hiddenColumns: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            columnType: "",
            columnName: "",
            defaultValue: "",
        };
    },
    methods: {
        isValid() {
            return true;
        },
        getAllowedColumns() {
            const preDefinedCols = [
                { id: "name", title: this.$t("wp.name") },
                { id: "age", title: this.$t("wp.age") },
                { id: "location", title: this.$t("wp.location") },
                { id: "tag", title: "Tag" },
                { id: "website", title: "Website" },
                { id: "Gender", title: this.$t("wp.gender") },
                { id: "custom", title: "Custom" },
            ];

            return preDefinedCols.filter((col) => !this.hiddenColumns.includes(col.id));
        },
        handleColumnTypeChange(val) {
            log("handleColumnTypeChange", val);
            const found = this.getAllowedColumns().find((col) => col.id === val);
            if (found) {
                this.columnType = found.id;
                if (val === "custom") {
                    this.columnName = "";
                } else {
                    this.columnName = val.title;
                }
            }
        },
        cancel() {
            this.onCancelled();
            this.columnName = "";
            this.defaultValue = "";
            this.columnType = "";
        },
        save() {
            if (_.isEmpty(this.columnName)) {
                this.$message.error("Column name is required");
                return;
            }
            this.onCompleted(this.columnName.toString().toLowerCase().trim(), this.defaultValue);
            this.columnName = "";
            this.defaultValue = "";
            this.columnType = "";
        },
    },
    mounted() {
        this.columnType = _.get(this.getAllowedColumns(), "0.id", "");
        this.columnName = _.get(this.getAllowedColumns(), "0.title", "");
    },
};
</script>

<style lang="scss">
.add-column-form {
    .form {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .field {
            margin-top: 5px;
            display: flex;
            flex-direction: column;
            gap: 3px;

            .label {
                font-size: 12px;
                color: #000;
                font-weight: 500;
            }
        }

        .buttons {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }
}
</style>
